import React from "react";
// import RouterErrorPage from "../../Layouts/Router/RouterErrorPage";

import Protected from "./Protected";
import Login from "../../pages/auth/Login";

export const Auth = {
  element: <Protected />,
  //   errorElement: <RouterErrorPage />,
  children: [
    {
      element: <Login />,
      path: "/",
    },
  ],
};
